import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ERequestApiStatus } from '../../types/appState';
import { ISessionToken, TSessionState } from '../../types/session';
import { SliceActions } from '../types';

const initialState: TSessionState = { status: ERequestApiStatus.Initial, token: null, uid: null };

const sessionSlice = createSlice({
  name: 'session',
  reducers: {
    setSessionPending: state => {
      state.status = ERequestApiStatus.Pending;
    },
    setSessionSucceed: (state, action: PayloadAction<ISessionToken>) => {
      state.status = ERequestApiStatus.Succeed;
      state.token = action.payload;
    },
    setSessionFailed: state => {
      state.status = ERequestApiStatus.Failed;
      state.token = null;
      state.uid = null;
    },
    setWsRegistration: (state, action: PayloadAction<string>) => {
      state.uid = action.payload;
    },
  },
  initialState: initialState satisfies TSessionState as TSessionState,
});

export const sessionReducer = sessionSlice.reducer;
export const { setSessionPending, setSessionFailed, setSessionSucceed, setWsRegistration } = sessionSlice.actions;
export type TSessionActions = SliceActions<typeof sessionSlice.actions>;
